import {Component, Input} from '@angular/core';
import {SpinnerComponent} from "src/app/presentation/common/spinner/spinner.component";

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  imports: [
    SpinnerComponent
  ],
  styleUrl: './action-button.component.css'
})
export class ActionButtonComponent {

  @Input() disabled: boolean = false
  @Input() useSpinner: boolean = false
  @Input() type: string = ''
  @Input() loading: boolean = false
  @Input() icon: string = ''
  @Input() btnClass: string = 'btn-info-action'
}
